angular
    .module('tradersyard')
    .factory('analytic-preview-storage', [
        'graph-analytic-factory',
        function (client) {
            var $preview = {
                prefix: 'analytic:preview:',
                get: function (space, next) {
                    client
                        .statistics(space, {
                            params: {
                                type: 'preview',
                            },
                        })
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                return next($response.data.data.preview);
                            }
                        });
                },
            };

            var $localStorage = {
                available: function () {
                    return typeof localStorage !== 'undefined';
                },
                quotaExceeded: function () {
                    try {
                        var key = '__test__key';
                        localStorage.setItem(key, key);
                        localStorage.removeItem(key);
                        return false;
                    } catch (e) {
                        var quotaExceeded = false;
                        if (e.code) {
                            switch (e.code) {
                                case 22:
                                    quotaExceeded = true;
                                    break;
                                case 1014:
                                    if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                                        quotaExceeded = true;
                                    }
                                    break;
                            }
                        } else if (e.number === -2147024882) {
                            quotaExceeded = true;
                        }
                        return quotaExceeded;
                    }
                },
                has: function (space) {
                    return localStorage.getItem($preview.prefix + space) !== null;
                },
                get: function (space) {
                    return JSON.parse(localStorage.getItem($preview.prefix + space));
                },
                set: function (space, data) {
                    if (!$localStorage.quotaExceeded()) {
                        localStorage.setItem($preview.prefix + space, JSON.stringify(data));
                    } else {
                        localStorage.clear();
                    }
                },
            };

            return {
                get: function (space, next) {
                    if ($localStorage.available()) {
                        if ($localStorage.has(space)) {
                            var $item = $localStorage.get(space);

                            if (moment().diff(moment($item.created_at), 'days') > 1) {
                                $preview.get(space, function (data) {
                                    var $item = {
                                        created_at: moment().format('YYYYMMDD'),
                                        updated_at: null,
                                        data: data,
                                    };
                                    $localStorage.set(space, $item);

                                    return next(data);
                                });
                            }

                            $item.updated_at = moment().format('YYYYMMDD');
                            $localStorage.set(space, $item);

                            return next($item.data);
                        }
                    }

                    $preview.get(space, function (data) {
                        if ($localStorage.available()) {
                            var $item = {
                                created_at: moment().format('YYYYMMDD'),
                                updated_at: null,
                                data: data,
                            };
                            $localStorage.set(space, $item);
                        }

                        return next(data);
                    });
                },
            };
        },
    ])
    .controller('analytic-preview-ctrl', [
        '$scope',
        'graph-analytic-factory',
        'analytic-preview-storage',
        'analytic-chart-factory',
        function ($scope, $factory, $storage, $chart) {
            $scope.space = 'me';
            $scope.process = false;
            $scope.preview = [];
            $scope.chart = $chart;

            $scope.init = function ($space) {
                if ($space) $scope.space = $space;

                $scope.find();
            };

            $scope.$entry = function ($space) {
                if ($space) $scope.space = $space;
            };

            $scope.find = function ($account) {
                if ($account) $scope.space = $account.id;

                $storage.get($scope.space, function ($data) {
                    if ($data.length === 0) return;

                    $scope.preview = $scope.chart.convert('preview', $data);
                });
            };
        },
    ]);
